import { render, staticRenderFns } from "./NumberCard.vue?vue&type=template&id=74f888ae&scoped=true&"
import script from "./NumberCard.vue?vue&type=script&lang=ts&"
export * from "./NumberCard.vue?vue&type=script&lang=ts&"
import style0 from "./NumberCard.vue?vue&type=style&index=0&id=74f888ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f888ae",
  null
  
)

export default component.exports